import { Reservation } from '../reservation.model';
import { RequestPassengerListStandby } from './requestPassengerListStandby.model';
import { getHiddenStopDepartureDate } from '@app/utils/functions/hidden-stop.utils';

export class RequestPassengerListUpgrade extends RequestPassengerListStandby {
  'hiddenStop-departureDate'?: string;

  constructor(reservation: Reservation) {
    super(reservation);
    const hiddenStopDate = getHiddenStopDepartureDate(reservation);
    if (hiddenStopDate) {
      this['hiddenStop-departureDate'] = hiddenStopDate;
    }
  }
}
